<template>
    <a class="plugin-about-media-item swiper-slide"
        v-bind:href="url"
        target="_blank"
        >
        <img class="plugin-about-media-item__image"
             v-bind:src="resizedImage"
             loading="lazy"
             alt=""
        />
    </a>
</template>

<script>
import utils from '~/utils';

export default {
    name: 'plugin-about-media-item',
    props: {
        image: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
    },
    computed: {
        resizedImage() {
            return utils.common.injectResize(this.image, '316xAUTO');
        },
    },
};
</script>

<style lang="less">
@import '~theme';

.plugin-about-media-item {
    position: relative;

    display: block;
    width: 206px;
    height: 138px;
    padding: 24px;
    border-radius: @border-radius-lg;
    border: 1px solid @color-gray-light;

    text-decoration: none;
    &__image {
        width: 100%;
        height: 100%;

        object-fit: cover;
    }
    @media @media-md-down {
        width: 152px;
        height: 100px;
        padding: 16px;
    }
}
</style>
